// ---------------------------------------------------------------------------
// main.js — compiled by the Node container to assets/js/main.js
// ---------------------------------------------------------------------------

import {
    createIcons,
    ArrowDown,
    ArrowUpRight,
    Check,
    Info,
    Lightbulb,
    MessageCircleQuestionMark,
    PhoneCall,
    ShoppingCart,
    Ticket,
} from "lucide";

// Alleen de iconen die in de templates (data-lucide) voorkomen; voeg een icoon
// hier toe zodra je er een nieuw gebruikt, anders blijft het leeg.
createIcons({
    icons: {
        ArrowDown,
        ArrowUpRight,
        Check,
        Info,
        Lightbulb,
        MessageCircleQuestionMark,
        PhoneCall,
        ShoppingCart,
        Ticket,
    },
});

const pageModules = {
    "plesk-licenties": () => import("./script/pages/products.js"),
    product: () => import("./script/pages/product.js"),
};

addEventListener("DOMContentLoaded", (event) => {
    // Vlag voor de failsafe in base.twig: zonder deze vlag haalt die na 4 s de 'js'-klasse weg.
    window.__revealReady = true;

    const page = document.body.dataset.page;

    // hasOwn: 'page' komt uit de URL, dus ook /constructor of /__proto__ moeten veilig zijn.
    if (Object.hasOwn(pageModules, page)) {
        pageModules[page]().then(async (module) => {
            await module.init();
        });
    }

    if (document.body.classList.contains("error404")) {
        import("./script/pages/not-found.js").then((module) => module.init());
    }

    // Scroll-reveal: eenmalig tonen zodra het element in beeld komt.
    const reveals = document.querySelectorAll(".reveal");
    if ("IntersectionObserver" in window) {
        const revealObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add("is-visible");
                    revealObserver.unobserve(entry.target);
                });
            },
            { threshold: 0.12 },
        );
        reveals.forEach((el) => revealObserver.observe(el));
    } else {
        reveals.forEach((el) => el.classList.add("is-visible"));
    }

    // Burgermenu (DaisyUI-dropdown, werkt op focus): houd aria-expanded in sync met de focus.
    document.querySelectorAll(".dropdown").forEach((dropdown) => {
        const trigger = dropdown.querySelector('[role="button"]');
        if (!trigger) return;

        dropdown.addEventListener("focusin", () =>
            trigger.setAttribute("aria-expanded", "true"),
        );
        dropdown.addEventListener("focusout", (event) => {
            if (!dropdown.contains(event.relatedTarget)) {
                trigger.setAttribute("aria-expanded", "false");
            }
        });
    });

    // De aura-animatie loopt oneindig; pauzeer hem zolang hij buiten beeld is.
    const auras = document.querySelectorAll(".aura");
    if (auras.length && "IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                entry.target.style.animationPlayState = entry.isIntersecting
                    ? "running"
                    : "paused";
            });
        });
        auras.forEach((aura) => observer.observe(aura));
    }
});
